// Thin client over the per-user navigation-layout API.
//   GET    /auth/navigation-layout/   → { layout }
//   PUT    /auth/navigation-layout/   → { success, layout }
//   DELETE /auth/navigation-layout/   → reset to default

import api from './api';
import { StoredLayout } from '../types/navLayout';

interface LayoutResponse {
  layout: StoredLayout | Record<string, never>;
}

interface SaveResponse {
  success: boolean;
  layout: StoredLayout;
}

function asLayout(raw: unknown): StoredLayout | null {
  if (raw && typeof raw === 'object' && Array.isArray((raw as StoredLayout).top)) {
    return raw as StoredLayout;
  }
  return null;
}

export const navigationLayoutService = {
  /** Returns the saved layout, or null if the user hasn't customized it yet. */
  async get(): Promise<StoredLayout | null> {
    const res = await api.get<LayoutResponse>('/auth/navigation-layout/');
    return asLayout(res?.layout);
  },

  async save(layout: StoredLayout): Promise<StoredLayout | null> {
    const res = await api.put<SaveResponse>('/auth/navigation-layout/', { layout });
    return asLayout(res?.layout) ?? layout;
  },

  async reset(): Promise<void> {
    await api.delete('/auth/navigation-layout/');
  },
};

export default navigationLayoutService;
